export default __webpack_public_path__ + "static/0017-8807bd147b9ceb2edc53e2626fa74f13.png";